<template>
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="4.5" width="18" height="16.5" rx="4.5" stroke="currentColor" stroke-width="2" />
        <path d="M8 2.75v3.5M16 2.75v3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <g fill="currentColor">
            <circle cx="8.25" cy="11.5" r="1.35" />
            <circle cx="12" cy="11.5" r="1.35" />
            <circle cx="15.75" cy="11.5" r="1.35" />
            <circle cx="8.25" cy="15.75" r="1.35" />
            <circle cx="12" cy="15.75" r="1.35" />
            <circle cx="15.75" cy="15.75" r="1.35" class="text-accent" fill="currentColor" />
        </g>
    </svg>
</template>
